import { render } from "./DiffValueCompare.vue?vue&type=template&id=1bdb9324"
import script from "./DiffValueCompare.vue?vue&type=script&lang=js"
export * from "./DiffValueCompare.vue?vue&type=script&lang=js"

import "./DiffValueCompare.vue?vue&type=style&index=0&id=1bdb9324&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__